import cost from "./cost";
import safety from "./safety";
import choosingSurgeon from "./choosingSurgeon";
import revision from "./revision";
import facelift from "./facelift";
import breastAugmentation from "./breastAugmentation";
import { noseHub, asian, revisionRhino } from "./nose";

// Registry of completed, substantial English SEO content pages.
export const SEO_PAGES = {
  [cost.slug]: cost,
  [safety.slug]: safety,
  [choosingSurgeon.slug]: choosingSurgeon,
  [revision.slug]: revision,
  [facelift.slug]: facelift,
  [breastAugmentation.slug]: breastAugmentation,
  [noseHub.slug]: noseHub,
  [asian.slug]: asian,
  [revisionRhino.slug]: revisionRhino,
};

// Slugs of completed pages that are approved for indexing (used by sitemap logic).
export const COMPLETED_SEO_SLUGS = Object.keys(SEO_PAGES);
